<div>
  <ng-container *ngIf="(transmittalStatus$ | async) === TransmittalSendingState.SENDING; else statusBlock">
    <p>{{ message | async }}</p>
  </ng-container>
  <ng-template #statusBlock>
    <p>{{ statusMessage | async }}</p>
  </ng-template>
</div>
<div class="completed-actions">
  <ng-container *ngIf="transmittalStatus$ | async as transmittalStatus">
    <button
      *ngIf="transmittalStatus === TransmittalSendingState.COUNTDOWN"
      type="button"
      mat-raised-button
      color="primary"
      class="aker-context-button"
      (click)="sendNow()"
    >
      <mat-icon>send</mat-icon>
      <span>Send Now</span>
    </button>

    <button
      *ngIf="transmittalStatus === TransmittalSendingState.COUNTDOWN"
      type="button"
      mat-raised-button
      color="warn"
      class="aker-context-button"
      (click)="cancelCountdown()"
    >
      <mat-icon>hourglass_bottom</mat-icon>
      <span>Cancel ({{ countDown }}s)</span>
    </button>

    <button
      *ngIf="transmittalStatus === TransmittalSendingState.SENDING"
      type="button"
      mat-raised-button
      disabled
      class="aker-context-button"
    >
      <mat-icon>cloud_upload</mat-icon>
      <span>Sending...</span>
    </button>

    <button
      *ngIf="transmittalStatus === TransmittalSendingState.SENT"
      type="button"
      mat-raised-button
      class="aker-context-button"
      (click)="reset()"
      aria-label="Prepare and send another transmittal"
    >
      <mat-icon>refresh</mat-icon>
      <span>Prepare and send another transmittal</span>
    </button>

    <button
      *ngIf="transmittalStatus === TransmittalSendingState.ERROR"
      type="button"
      mat-raised-button
      color="primary"
      class="aker-context-button"
      (click)="transmittalStatus$.next(TransmittalSendingState.COUNTDOWN)"
    >
      <mat-icon>replay</mat-icon>
      <span>Retry sending</span>
    </button>

    <button
      *ngIf="transmittalStatus === TransmittalSendingState.CANCELLED"
      type="button"
      mat-raised-button
      color="primary"
      class="aker-context-button"
      (click)="transmittalStatus$.next(TransmittalSendingState.COUNTDOWN)"
    >
      <mat-icon>play_arrow</mat-icon>
      <span>Restart countdown</span>
    </button>
  </ng-container>
</div>
